import axiosInstance from ".";

export const getAbout = () => {
  return axiosInstance.get("/about");
};

export const updateAbout = (data) => {
  return axiosInstance.post("/about", data);
};
